
import { observable, action } from 'mobx';
import { mesAutobind, instance } from '@posco/posco-shared';


@mesAutobind
class ItemUiStore {

  @instance
  static instance;

  @observable
  folding = false;


  @action
  clear() {
    this.folding = false;
  }

  @action
  setFolding(folding) {
    this.folding = folding;
  }
}

export default ItemUiStore;

